export const AUTO_SCROLL_START_DELAY = 300;

export const ITEM_INITIAL_INDEX = -1;

export const DATA_DRAGGABLE_PLACEHOLDER_KEY = 'data-draggable-placeholder';

export const DATA_DRAGGABLE_PLACEHOLDER_REACT_PROP: {
  'data-draggable-placeholder': string;
} = { [DATA_DRAGGABLE_PLACEHOLDER_KEY]: 'true' };
